import { useContext } from "react";
import BootstrapNavbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import logo from "./logo.png";
import { Link } from "react-router-dom";
import NavDropdown from "react-bootstrap/NavDropdown";
import LanguageSelector from "../../utils/LanguageSelector";
import { Text, LanguageContext } from "../../utils/Language";
import Notifications from "./Notifications/Notifications";
import { LoginService } from "../../services";
import generatedGitInfo from "../../generatedGitInfo.json"

function Navbar() {
  const { dictionary } = useContext(LanguageContext);
  const user = LoginService.getUser();
  if (user && user.UserId) {
    const personelId = Number(user.personelid || user.personelId || 0);
    const isInternal = personelId === 1 || personelId === 2;
    const brandLink = isInternal ? "/work-receipt" : "/patients";
    const listLink = isInternal ? "/work-receipt" : "/patients";
    const listLabelKey = isInternal ? "WorkReceipt" : "Patients";

    return (
      <>
        <BootstrapNavbar
          sticky="top"
          collapseOnSelect
          expand="md"
          bg="light"
          variant="light"
        >
          <BootstrapNavbar.Brand as={Link} to={brandLink}>
            <img
              src={logo}
              height="50"
              className="d-inline-block align-top"
              alt="Dentaline logo"
            />
          </BootstrapNavbar.Brand>
          <BootstrapNavbar.Toggle aria-controls="responsive-navbar-nav" />
          <BootstrapNavbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link as={Link} to={listLink}>
                <Text tid={listLabelKey} />
              </Nav.Link>
            </Nav>
            <Notifications />

            <Nav>
              <NavDropdown
                title={user.LongName}
                className="mx-3"
                id="collasible-nav-dropdown"
              >
                <NavDropdown.Item as={Link} to="/profile">
                  <Text tid="Profile" />
                </NavDropdown.Item>
                <NavDropdown.Item href="/patientfiles">
                  <Text tid="FileRecords" />
                </NavDropdown.Item>
                <NavDropdown.Item href="#">
                  <Text tid={"Version " + generatedGitInfo.gitCommitHash}/>
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item as={Link} to="/logout">
                  <Text tid="Logout" />
                </NavDropdown.Item>
              </NavDropdown>
            </Nav>
            <Nav>
              <LanguageSelector></LanguageSelector>
            </Nav>
          </BootstrapNavbar.Collapse>
        </BootstrapNavbar>
      </>
    );
  }
}

export default Navbar;
